import { Country } from '../apiTypes';

export type Currency = '₴' | '€';

export const currencies: Currency[] = ['₴', '€'];

export const countriesMap: Record<Country, string> = {
  ua: 'Україна',
  es: 'España',
  other: 'Other',
};

export const countries: Country[] = ['ua', 'es', 'other'];
